// Shared Data type for all page +data.ts hooks.
//
// The slug page returns GlobalData (no listings).
// The results page extends it with listings fields.
// The union type is what +Page.tsx and seedCache consume.

import type { UnitsClientList } from "@superbright/indexeddb-orm";

import type { GlobalData } from "./_fetchGlobalData";

export type ResultsData = GlobalData & {
  listings: UnitsClientList | null;
  listings_api_params: unknown | null;
};

export type Data = GlobalData | ResultsData;

/** Type guard: does the data include listings fields? */
export function hasListings(data: Data): data is ResultsData {
  return "listings" in data;
}
